import React from 'react'
import PropTypes from 'prop-types'

function BottomHeaderRowJob({ jobId, invitationUrl = '', role }) {
  return (
    <div className="header__row is-with-border">
      <div className="header__conversation-actions u-float-right">
        {invitationUrl ? (
          <a href={invitationUrl} className="button">{role === 'designer' ? 'Apply to 3D Project' : 'Review Project details'}</a>
        ) : (
          <a href={`/profile/projects/${jobId}`} className="button">View in 3D Projects dashboard</a>
        )}
      </div>
    </div>
  )
}

BottomHeaderRowJob.propTypes = {
  jobId: PropTypes.number.isRequired,
  invitationUrl: PropTypes.string,
  role: PropTypes.string.isRequired,
}

export default BottomHeaderRowJob
